import React from 'react';
import nt_main from '../img/nt_main.jpg';
const WhoIAm = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">   
            <div>
                My background in legal, trading and corporate environments means I understand pressure, 
                hierarchy and complex decision-making. I read emotional patterns quickly,especially 
                in people who carry a lot of responsibility and are used to high performance. 
                Those who work with me gain clarity, safety and direction.
            </div>
            <div><img src={nt_main} alt="Nadya Taylor Psychological Strategist" /> </div>
            <div>
               I work where psychological depth meets strategic clarity.
My style is calm,clear and direct. I help people organise their thoughts, 
settle their emotions and see their next step with confidence and clarity.

            </div>
             <div>
        Clients describe my approach as a mix of honesty, emotional insight and strategic 
        thinking. Russian-speaking clients appreciate my directness and grounded presence. 
        English-speaking clients value my clear communication and my ability to see what 
        sits behind surface behaviour.
         I bring both worlds into my work.
            </div>
            <div>
               I support ambitious, self-aware individuals, both men and women, who are ready for 
               deeper psychological insight that leads to real change. Through the use of recognised psychological methods, 
               I help people understand their patterns, strengthen their 
               confidence, increase awareness of subconcious behavior patterns, resulting in an imporvement in outcomes 
               in their personal and professional lives.
            </div>
           </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
          
            <div>в разработке</div>
            <div><img src={nt_main} alt="Надежда Тейлор психолог-стратег" /> </div>
    
            </div>
        );
    }
}
export default WhoIAm;
